import React from 'react'

const ToastrContext = React.createContext()

export default ToastrContext
